"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const formik_1 = require("formik");
const styles_1 = __importDefault(require("../../styles/styles"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const select_1 = __importDefault(require("../select/select"));
const notificationConstants_1 = require("../../features/notifications/notificationConstants");
const notificationSlice_1 = require("../../features/notifications/notificationSlice");
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const constants_1 = require("../../constants/constants");
const FilterNotification = ({ queryParams, setQueryParams, }) => {
    const dispatch = useAppDispatch_1.default();
    const isDesktop = useWebDesktopDesign_1.default(constants_1.DESKTOP_BREAKPOINT_2);
    const onSubmit = (payload) => {
        const updatedPayload = {
            ...payload,
        };
        dispatch(notificationSlice_1.getNotifications(updatedPayload));
        setQueryParams(updatedPayload);
    };
    return (react_1.default.createElement(formik_1.Formik, { initialValues: queryParams, onSubmit: (values) => onSubmit(values) }, ({ handleSubmit, values, setFieldValue }) => (react_1.default.createElement(react_native_1.View, { style: isDesktop ? [styles_1.default.flexDirectionRow] : styles_1.default.flexDirectionColumn },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(select_1.default, { value: values.read, setValue: () => { }, setValueFormik: (value) => {
                    setFieldValue('read', value);
                    handleSubmit();
                }, choices: notificationConstants_1.FILTER_READ_STATUS_CHOICES, style: [styles_1.default.marginBottomTen, { height: 45 }] })),
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(select_1.default, { value: values.content_type, setValue: () => { }, setValueFormik: (value) => {
                    setFieldValue('content_type', value);
                    handleSubmit();
                }, choices: notificationConstants_1.FILTER_CONTENT_TYPE_CHOICES, style: [styles_1.default.marginBottomTen, { height: 45 }] }))))));
};
exports.default = FilterNotification;
